import { render, staticRenderFns } from "./LabelSetsCompact.vue?vue&type=template&id=a8a95ed8&scoped=true&"
import script from "./LabelSetsCompact.vue?vue&type=script&lang=js&"
export * from "./LabelSetsCompact.vue?vue&type=script&lang=js&"
import style0 from "./LabelSetsCompact.vue?vue&type=style&index=0&id=a8a95ed8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a95ed8",
  null
  
)

export default component.exports